import 'core-js/es6/map'
import 'core-js/es6/set'
import 'core-js/es6/symbol'
import 'core-js/fn/array/find'
import 'core-js/fn/array/find-index'
import 'core-js/fn/array/from'
import 'core-js/fn/array/includes'
import 'core-js/fn/string/includes'
import 'core-js/fn/string/ends-with'



// WEBPACK FOOTER //
// ./src/polyfills.js